import { DynamicBaseForm } from './dynamic-base-form';

export class TitleForm extends DynamicBaseForm<string> {
    controlType = 'TitleForm';
}